module.exports = __webpack_public_path__ + "assets/img/00035.f71f8223.png";